export default __webpack_public_path__ + "static/media/lsen.227e3195.jpg";